export const rolesRequestList_actionType = {
    ROLES_REQUEST_LIST_START: "ROLES_REQUEST_LIST_START",
    ROLES_REQUEST_LIST_SUCCESS: "ROLES_REQUEST_LIST_SUCCESS",
    ROLES_REQUEST_LIST_ERROR: "ROLES_REQUEST_LIST_ERROR",
    ROLES_REQUEST_LIST_SELECT_REQUEST: "ROLES_REQUEST_LIST_SELECT_REQUEST"
};